import type { SunAdminOptions } from "../types";
export const apiConfig: SunAdminOptions["apiConfig"] = {
    baseURL: "",
    timeout: 0,
    headers: {},
    wsUrl: "",
};
